import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import BarPositiveAndNegative from "components/visuals/BarPositiveAndNegative";

import { selectors } from "modules/customer/insights/portfolio/catchment/demographicBreakdown";

const ChildrenIndex = () => {
    const childrenIndex = useSelector(state => selectors.childrenIndex(state));
    const { loading, error, categories, values } = childrenIndex;
    
    const options = {
        title: {
            text: "Number of children"
        },
        xAxis: [
            { categories: categories },
            {}
        ],
        series: [{
            data: values
        }]
    };

    return (
        <Box data-cy="children-index">
            <BarPositiveAndNegative loading={loading} error={error} options={options} />
        </Box>
    );
};

export default ChildrenIndex;
